export default __webpack_public_path__ + "static/media/data.f79973c3.webp";